import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import Close from '../../assets/img/close.svg';

import './confirm.scss';


class Confirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: props.visible
    };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState({
        isOpened: this.props.visible
      });
    }
  }

  onButtonClick() {
    if (this.props.disabled) {
      this.props.onConfirm();
      return false;
    }

    // Since the modal is inside the button click events will propagate up.
    if (!this.state.isOpened) {
      this.setState({
        isOpened: true
      });
    }
  }

  onClose(event) {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false
    });

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  }

  onConfirm(event) {
    event.stopPropagation();
    this.setState({
      isOpened: false
    });
    this.props.onConfirm();
  }

  render() {
    var cancelButton = this.props.showCancelButton ? (
      <Button variant="secondary" onClick={this.onClose}>
        {this.props.cancelText}
      </Button>
    ) : null;
    var modal = (
      <Modal
        show={this.state.isOpened}
        onHide={this.onClose}
        className={`confirm_modal ${this.props.className || ' '}`}
        dialogClassName={this.props.dialogClassName}
        keyboard={this.props.keyboard}
        backdrop={this.props.backdrop}
        enforceFocus={this.props.enforceFocus}
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.title}
          </Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>{this.props.body}</Modal.Body>
        <Modal.Footer>
          <Button className={`${this.props.confirmClass || 'btn-danger'}`} onClick={this.onConfirm}>
            <img src={this.props.icon} alt="#" />
            {this.props.confirmText}
          </Button>
          {cancelButton}
        </Modal.Footer>
      </Modal>
    );
    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          onClick: this.onButtonClick,
          style: this.props.style
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }
    return content;
  }
}

Confirm.propTypes = {
  body: PropTypes.node.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.node,
  cancelText: PropTypes.node,
  className: PropTypes.string,
  confirmBtn: PropTypes.string,
  confirmText: PropTypes.node,
  dialogClassName: PropTypes.string,
  keyboard: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  enforceFocus: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showCancelButton: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  visible: PropTypes.bool
};

Confirm.defaultProps = {
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  showCancelButton: true
};

export { Confirm };
export default Confirm;
